module.exports = __webpack_public_path__ + "static/media/33000149.76454047.png";